import styled, { css } from 'styled-components';

import mixin from '../../../../_foundations/Mixin';

const DropdownButtonComponent = styled.a`
  ${mixin.text({ size: 200, strong: true })};
  height: 2.5rem;
  display: flex;
  padding: 0.5rem;
  color: var(--neutral-900);
  border-radius: 8px;
  width: 100%;
  align-items: center;

  ${({ selected }) => selected && 'border: 2px solid #000;'}
  ${({ danger }) => danger && 'color: var(--danger-500);'}

  &:hover {
    cursor: pointer;
    background-color: var(--neutral-100);
    color: var(--neutral-900);
    text-decoration: none;
    ${({ danger }) => danger && 'color: var(--danger-500);'}
  }

  &:focus {
    border: 3px solid var(--blue-200);
  }

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      color: var(--neutral-400);
    `}

  i {
    color: var(--neutral-400);
  }
`;

export default DropdownButtonComponent;
